import * as React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Input, Label } from "reactstrap";
import { DeleteManagedService, UpdateManagedService } from "./ManagedServiceStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SendEmail } from "../email/EmailStore";
import { ConfigFormField } from "../organizations/OrganizationManagedServices";

interface ManagedServiceInstanceProps {
    managedService: any;
    onChange: Function;
}

const ManagedServiceInstance = ({ managedService, onChange }: ManagedServiceInstanceProps) => {
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const [emailTestAddress, setEmailTestAddress] = React.useState("");
    const [emailTestText, setEmailTestText] = React.useState("");

    const deleteManagedService = () => {
        DeleteManagedService(managedService.organizationID, managedService.id).then(() => {
            setShowDeleteModal(false);
            onChange && onChange();
        });
    };

    const startDeleteManagedService = () => {
        setShowDeleteModal(true);
    };
    const toggleDeleteModal = () => {
        setShowDeleteModal(!showDeleteModal);
    };

    const sendTestMail = () => {
        SendEmail(emailTestAddress, "Test Mail", emailTestText).then(() => {
            setEmailTestAddress("");
            setEmailTestText("");
        });
    };

    const [syncTimetables, setSyncTimetables] = React.useState(managedService?.configuration?.syncTimetables);

    React.useEffect(() => {
        updateManagedService();
    }, [syncTimetables]);

    const [limitTo, setLimitTo] = React.useState(managedService?.configuration?.limitTo);

    const updateManagedService = () => {
        if (managedService.type == 0) {
            UpdateManagedService(managedService.organizationID, { ...managedService, configuration: { ...managedService.configuration, limitTo } }).then(() => {});
        }

        if (managedService.type == 2) {
            UpdateManagedService(managedService.organizationID, { ...managedService, configuration: { ...managedService.configuration, syncTimetables } }).then(() => {});
        }

        if (managedService.type == 7) {
            UpdateManagedService(managedService.organizationID, { ...managedService, configuration: { ...managedService.configuration, defaultTemplateID, loginLinkTemplateID, transactionalAsmGroupID, vouchersAsmGroupID, marketingAsmGroupID, formsAsmGroupID } }).then(() => {});
        }
    };

    const [defaultTemplateID, setDefaultTemplateID] = React.useState(managedService?.configuration?.defaultTemplateID || "");
    const [loginLinkTemplateID, setLoginLinkTemplateID] = React.useState(managedService?.configuration?.loginLinkTemplateID || "");
    const [transactionalAsmGroupID, setTransactionalAsmGroupID] = React.useState(managedService?.configuration?.transactionalAsmGroupID || 0);
    const [vouchersAsmGroupID, setVouchersAsmGroupID] = React.useState(managedService?.configuration?.vouchersAsmGroupID || 0);
    const [marketingAsmGroupID, setMarketingAsmGroupID] = React.useState(managedService?.configuration?.marketingAsmGroupID || 0);
    const [formsAsmGroupID, setFormsAsmGroupID] = React.useState(managedService?.configuration?.formsAsmGroupID || 0);

    return (
        <div>
            {managedService.type == 1 && (
                <>
                    <h4>SASAMS Agent</h4>
                    <div>Download the SASAMS agent to start your enrolment</div>

                    <div>
                        <a href="https://www.scadco.co.za/sasams365/sasams-365.application">Download</a>
                    </div>
                </>
            )}
            {managedService.type == 2 && (
                <>
                    <h4>Scadsys</h4>
                    <FormGroup check>
                        <Input type="switch" id={"syncTimetables"} checked={syncTimetables} onChange={(e) => setSyncTimetables(e.target.checked)} />
                        <Label for={"syncTimetables"} check>
                            Sync Scadsys Timetables
                        </Label>
                    </FormGroup>
                </>
            )}

            {managedService.type == 3 && (
                <>
                    <h4>{managedService.configuration.name}</h4>
                    <img className="pl-2" src={managedService.configuration.logoUri} alt="" style={{ height: "75px" }} />
                </>
            )}

            {managedService.type == 4 && (
                <>
                    <h4>{managedService.configuration.name}</h4>
                </>
            )}

            {managedService.type == 5 && (
                <>
                    <h4>
                        Azure{" "}
                        {managedService.configuration.adminConsentGranted && (
                            <>
                                {/* @ts-ignore */}
                                <FontAwesomeIcon color="var(--bs-green)" icon={["fad", "circle-check"]}></FontAwesomeIcon>
                            </>
                        )}
                    </h4>
                    <div>Tenant ID: {managedService.configuration.tenantID}</div>
                    <div>
                        {managedService.configuration.adminConsentGranted && (
                            <div>
                                <span>Granted at: </span>
                                <span>{managedService.configuration.adminConsentGrantedTimestamp}</span>
                                <br />
                                <a href={`/Azure/InitiateAdminConsent?managedServiceId=${managedService.id}`}>Update Admin Consent</a>
                            </div>
                        )}
                        {!managedService.configuration.adminConsentGranted && (
                            <div>
                                <a href={`/Azure/InitiateAdminConsent?managedServiceId=${managedService.id}`}>Initiate Admin Consent</a>
                            </div>
                        )}

                        {managedService.configuration.eventsAdminConsentGranted && (
                            <div>
                                <span>Granted at: </span>
                                <span>{managedService.configuration.eventsAdminConsentGrantedTimestamp}</span>
                                <br />
                                <a href={`/Azure/InitiateScadsysEventsAdminConsent?managedServiceId=${managedService.id}`}>Update Scadsys Events Admin Consent</a>
                            </div>
                        )}
                        {!managedService.configuration.eventsAdminConsentGranted && (
                            <div>
                                <a href={`/Azure/InitiateScadsysEventsAdminConsent?managedServiceId=${managedService.id}`}>Initiate Scadsys Events Admin Consent</a>
                            </div>
                        )}
                    </div>
                </>
            )}

            {managedService.type == 6 && (
                <>
                    <h4>COVID Screening</h4>
                </>
            )}

            {managedService.type == 7 && (
                <>
                    <h4>SendGrid</h4>
                    <label>Send Test Mail To:</label>
                    <input className="form-control" value={emailTestAddress} onChange={(e) => setEmailTestAddress(e.target.value)} />
                    <label>Test Mail Text:</label>
                    <input className="form-control" value={emailTestText} onChange={(e) => setEmailTestText(e.target.value)} />
                    <button className="btn btn-primary" onClick={sendTestMail}>
                        Send Test Mail
                    </button>

                    <FormGroup>
                        <Label>Default Template ID</Label>
                        <Input type="text" value={defaultTemplateID} onChange={(e) => setDefaultTemplateID(e.target.value)} onBlur={updateManagedService} />
                    </FormGroup>

                    <FormGroup>
                        <Label>Login Link Template ID</Label>
                        <Input type="text" value={loginLinkTemplateID} onChange={(e) => setLoginLinkTemplateID(e.target.value)} onBlur={updateManagedService} />
                    </FormGroup>

                    <FormGroup>
                        <Label>Transactional ASM Group ID</Label>
                        <Input type="number" value={transactionalAsmGroupID} onChange={(e) => setTransactionalAsmGroupID(e.target.valueAsNumber)} onBlur={updateManagedService} />
                    </FormGroup>

                    <FormGroup>
                        <Label>Vouchers ASM Group ID</Label>
                        <Input type="number" value={vouchersAsmGroupID} onChange={(e) => setVouchersAsmGroupID(e.target.valueAsNumber)} onBlur={updateManagedService} />
                    </FormGroup>

                    <FormGroup>
                        <Label>Marketing ASM Group ID</Label>
                        <Input type="number" value={marketingAsmGroupID} onChange={(e) => setMarketingAsmGroupID(e.target.valueAsNumber)} onBlur={updateManagedService} />
                    </FormGroup>

                    <FormGroup>
                        <Label>Forms ASM Group ID</Label>
                        <Input type="number" value={formsAsmGroupID} onChange={(e) => setFormsAsmGroupID(e.target.valueAsNumber)} onBlur={updateManagedService} />
                    </FormGroup>
                </>
            )}

            {managedService.type == 8 && (
                <>
                    <h4>Discord</h4>
                    <div>{managedService.configuration.guildID}</div>
                    <div>{managedService.configuration.guildName}</div>
                </>
            )}

            {managedService.type == 0 && (
                <>
                    <h4>Link</h4>
                    <img src={managedService.configuration.imageURI} width="64"></img>
                    <div>{managedService.configuration.name}</div>
                    <a href={managedService.configuration.link} target="_blank">
                        Link
                    </a>

                    <FormGroup>
                        <Label>Limit To</Label>
                        <Input type="text" value={limitTo} onChange={(e) => setLimitTo(e.target.value)} onBlur={updateManagedService} />
                        <small>Comma seperated list of (0=staff,1=student,2=parent,4=guest)</small>
                    </FormGroup>
                </>
            )}

            <div className="d-flex justify-content-end w-100">
                <Button color="danger" onClick={startDeleteManagedService}>
                    Delete ManagedService
                </Button>
            </div>
            <Modal isOpen={showDeleteModal} toggle={toggleDeleteModal}>
                <ModalHeader toggle={toggleDeleteModal}>Delete ManagedService</ModalHeader>
                <ModalBody>Are You sure you want to delete ?</ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={deleteManagedService}>
                        Delete
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleDeleteModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ManagedServiceInstance;
